// UniversalProgressBar.jsx - Finale mooie versie
import React from 'react';

const UniversalProgressBar = ({ currentStep, steps, isVisible, conversationActive, onClose }) => {
  const maxSteps = 5;
  const progressPercentage = Math.min(Math.max((currentStep / maxSteps) * 100, 0), 100);
  const isCompleted = currentStep >= maxSteps && !conversationActive; // NIEUWE REGEL

  const getStepTitle = () => {
    if (currentStep === 0) return "Klaar om te beginnen";
    if (currentStep === 1) return "Functie besproken";
    if (currentStep === 2) return "Werkzaamheden verzameld"; 
    if (currentStep === 3) return "Voordelen besproken";
    if (currentStep === 4) return "Eisen vastgesteld";
    if (currentStep >= 5) return "Vacature voltooid!";
    return "Bezig...";
  };
  
  const getCurrentStepDescription = () => {
    if (currentStep === 0) return "Vertel Job welke functie je zoekt";
    if (currentStep === 1) return "Functie begrepen! Wat worden de belangrijkste werkzaamheden?";
    if (currentStep === 2) return "Bespreken van belangrijkste taken en verantwoordelijkheden";
    if (currentStep === 3) return "Waarom zouden mensen voor deze functie kiezen?";
    if (currentStep === 4) return "Uitwerken van eisen, salaris en voorwaarden";
    if (currentStep >= 5) return "Klaar om te downloaden!";
    return "Job denkt na...";
  };
  
  // Visibility logic: toon als gesprek actief is OF als voltooid
  if (!conversationActive && currentStep < maxSteps) {
    return null;
  }
  
  if (!isVisible && currentStep === 0) {
    return null;
  }
  
  return (
    <div className={`mobile-progress-bar ${isVisible ? 'visible' : ''} ${isCompleted ? 'completed' : ''}`}>
      {/* VOEG DEZE CLOSE BUTTON TOE */}
      {isCompleted && (
        <button 
          className="progress-close-btn"
          onClick={onClose}
          title="Sluit voortgangsbalk"
          aria-label="Sluit voortgangsbalk"
        >
          ×
        </button>
      )}
      <div className="mobile-progress-info">
        <div className="mobile-progress-title">
          {getStepTitle()}
        </div>
        <div className="mobile-progress-percentage">
          {Math.round(progressPercentage)}%
        </div>
      </div>
      
      <div className="mobile-progress-track">
        <div 
          className="mobile-progress-fill"
          style={{ width: `${progressPercentage}%` }}
        ></div>
      </div>
      
      <div className="mobile-current-step">
        {getCurrentStepDescription()}
      </div>
    </div>
  );
};

export default UniversalProgressBar;